import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PageHeadingNew from "../../../common-components/custom-comps/PageHeadingNew";
import { CalendarIcon, FilterIcon, ExportIcon } from "../../../../images/icons/icons";
import PipelineStagesOverview from "./PipelineStagesOverview";
import ClosureExpectedTracker from "./ClosureExpectedTracker";
import DashboardMetrics from "./DashboardMetrics";
import ClosureExpectedDeepTracker from "./ClosureExpectedDeepTracker";
import DailyMovementReconciliation from "./DailyMovementReconciliation";

const PipelineTracker = ({userInfoData}) => {
  return (
    <>
      <Row>
        <Col>
          <div className="lms-closure-pipeline-tracker-header">
            {/* <div className="lms-closure-pipeline-tracker-header-left">
              <PageHeadingNew
                heading="Pipeline Tracker"
                subheading="Monitor daily lead movement and pipeline flow"
              />
            </div> */}
            <div className="lms-closure-pipeline-tracker-header-right">
              {/* <div className="lms-closure-pipeline-tracker-action-buttons">
                <button className="lms-closure-pipeline-tracker-btn-action">
                  <CalendarIcon className="lms-closure-pipeline-tracker-btn-icon" />
                  Date Range
                </button>
                <button className="lms-closure-pipeline-tracker-btn-action">
                  <FilterIcon className="lms-closure-pipeline-tracker-btn-icon" />
                  Filter
                </button>
                <button className="lms-closure-pipeline-tracker-btn-action">
                  <ExportIcon className="lms-closure-pipeline-tracker-btn-icon" />
                  Export
                </button>
              </div> */}
            </div>
          </div>
        </Col>
      </Row>

      {/* Pipeline Stages Overview */}
      <Row>
        <Col>
          <PipelineStagesOverview userInfoData={userInfoData} />
        </Col>
      </Row>

      {/* Closure Expected Tracker */}
      <Row>
        <Col>
          <ClosureExpectedTracker userInfoData={userInfoData} />
        </Col>
      </Row>

      {/* Dashboard Metrics */}
      <Row>
        <Col>
          <DashboardMetrics userInfoData={userInfoData} />
        </Col>
      </Row>

      {/* Closure Expected Deep Tracker */}
      <Row>
        <Col>
          <ClosureExpectedDeepTracker userInfoData={userInfoData} />
        </Col>
      </Row>

      {/* Daily Movement Reconciliation */}
      <Row>
        <Col>
          <DailyMovementReconciliation userInfoData={userInfoData} />
        </Col>
      </Row>
    </>
  );
};

export default PipelineTracker;
